export const PROFILE_SELECT = 'PROFILE_SELECT';

export function selectProfile(profileId) {
  return {
    type: PROFILE_SELECT,
    payload: profileId
  };
}
